<template>
  <div class="footer-page footer-page-selection">
    <div class="footer-content-page">
      <f7-row
        class="row-selector"
      >
        <f7-col
          class="selector-type"
        >
          <f7-row class="row-logo">
            <img
              class="logo-vegsyst"
            >
            <span class="title-gh">VegSyst-DSS</span>
          </f7-row>
          <f7-button
            name="btnSignIn"
            class="botonSecundary btn-selection"
            col
            button
            button-raised
            fill
            style="color:#FFFFFF"
            @click="goToGreenhouse"
          >
            {{ $t("botton_goToGreenhouse") }}
          </f7-button>
        </f7-col>
        <f7-col
          class="selector-type"
        >
          <f7-row class="row-logo">
            <img
              class="logoAireLibre"
            >
            <span class="title-ex">VegSyst-DSS</span>
          </f7-row>
          <f7-button
            name="btnSignIn"
            class="botonPrimary btn-selection"
            col
            button
            button-raised
            fill
            style="color:#FFFFFF"
            @click="goToOpenAir"
          >
            {{ $t("botton_goToOpenAir") }}
          </f7-button>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { APPLICATION_NAME, APP_LOGO } from '../../js/constants';

export default {
  name: 'Login',
  components: {
  },
  props: {
    hasRestorePass: { type: Boolean, default: false },
    hasSignUp: { type: Boolean, default: false },
    hasRememberMe: { type: Boolean, default: false },
    hasNeedHelp: { type: Boolean, default: false },
  },
  data() {
    return {
      username: '',
      password: '',
      APPLICATION_NAME,
      APP_LOGO,
      keyName1: 'GreenHouse',
      keyName2: 'OpenAir',
    };
  },
  computed: {
    btnDisable() {
      return this.username && !this.password;
    },
    appLogo() {
      return localStorage.getItem('applogo') || this.APP_LOGO;
    },
    ...mapState('authentication', ['isLogged', 'wantToRemember']),
    ...mapState('NewRegister', ['isNewUser']),
  },

  methods: {
    signUp() {
      const self = this;
      const router = self.$f7router;
      router.navigate('/recoveryPasswordPage/', { reloadCurrent: true });
    },
    quit() {
      const self = this;
      const router = self.$f7router;
      router.back();
    },
    newUser() {
      this.setIsNewUser(true);
    },
    goToGreenhouse() {
      this.setSelection(this.keyName1);
      this.setShowLeftPanel(true);
      this.$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true });
    },
    goToOpenAir() {
      this.setSelection(this.keyName2);
      this.setShowLeftPanel(true);
      this.$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true });
    },
    ...mapActions('authentication', ['login', 'setSelection', 'setShowLeftPanel']),
    ...mapActions('NewRegister', ['setIsNewUser']),
    ...mapMutations('authentication', ['setWantToRemember', 'wantToRecoveryPass', 'changePassword']),
  },
};
</script>

<style lang="scss" scoped>
@import "./selection.scss";
@import "../../css/mixins";

.logoAireLibre{
  content: url("../../static/icons/icon-ex.png");
  width: auto;
  margin-bottom: 1rem;
  height: 45px;
  @include md {
    height: 60px;
  }
}
.logo-vegsyst{
  content: url("../../static/icons/icon-gh.png");
  width: auto;
  margin-bottom: 1rem;
  height: 45px;
  @include md {
    height: 60px;
  }
}

.btn-selection {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1.25rem;
}
.footer-content-page {
  height: 85vh;
  @include md {
    height: auto;
  }
}
</style>
